<!-- 实体关联 -->
<template>
  <div class="entity-association-view">
    <el-form :model="caseDataInfo" :rules="rules">
      <div class="entity-association-block">
        <el-form-item label="所属服务商企业编号：" label-width="190px">
          <el-input
            style="width: 700px"
            v-model="caseDataInfo.companyServiceId"
            placeholder="请输入所属服务商企业编号"
          />
        </el-form-item>

        <el-form-item label="所属服务商企业：" label-width="190px">
          <el-input
            style="width: 700px"
            v-model="caseDataInfo.serviceCompanyFullName"
            placeholder="请输入所属服务商企业"
          />
        </el-form-item>

        <el-form-item label="所属产品编号：" label-width="190px">
          <el-input
            v-model="caseDataInfo.productId"
            style="width: 700px"
            placeholder="请输入所属产品编号"
          />
        </el-form-item>

        <el-form-item label="所属产品全称：" label-width="190px">
          <el-input
            v-model="caseDataInfo.productName"
            style="width: 700px"
            placeholder="请输入所属产品全称"
          />
        </el-form-item>

        <el-form-item label="所属解决方案编号：" label-width="190px">
          <el-input
            v-model="caseDataInfo.association"
            style="width: 700px"
            placeholder="请输入所属解决方案编号"
          />
        </el-form-item>

        <el-form-item label="所属解决方案全称：" label-width="190px">
          <el-input
            v-model="caseDataInfo.solutionName"
            style="width: 700px"
            placeholder="请输入所属解决方案全称"
          />
        </el-form-item>

        <el-form-item label="所属场景编号：" label-width="190px">
          <el-input
            v-model="caseDataInfo.sceneId"
            style="width: 700px"
            placeholder="请输入所属场景编号"
          />
        </el-form-item>

        <el-form-item label="所属场景全称：" label-width="190px">
          <el-input
            v-model="caseDataInfo.sceneName"
            style="width: 700px"
            placeholder="请输入所属场景全称"
          />
        </el-form-item>
      </div>

      <p class="info-title">关联案例客户企业信息</p>

      <div class="entity-association-block">
        <el-form-item label="是否是智参企业：" label-width="190px">
          <el-radio-group v-model="checked">
            <el-radio
              v-for="(item, index) in query.judgeArray"
              :key="index"
              :label="item.label"
            ></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          prop="companyCode"
          label="所属智参企业编号："
          label-width="190px"
        >
          <el-autocomplete
            v-model="caseDataInfo.companyCode"
            :fetch-suggestions="companyCodeChange"
            @select="companyCodeHandle"
            style="width: 700px"
            placeholder="请输入所属智参企业编号"
          />
        </el-form-item>

        <el-form-item label="所属智参企业全称：" label-width="190px">
          <el-autocomplete
            v-model="caseDataInfo.clientCompanyName"
            :fetch-suggestions="companyNameChange"
            @select="companyNameHandle"
            style="width: 700px"
            placeholder="请输入所属智参企业全称"
          />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getByCompanyCode, getZcByCompanyName } from "@/api/plan";
export default {
  data() {
    //这里存放数据
    return {
      // 表单验证规则
      rules: {},
      checked: "否",
      query: {
        judgeArray: [
          { label: "是", value: 1 },
          { label: "否", value: 0 }
        ]
      },
      companyNameList: [],
      companyCodeList: []
    };
  },
  props: {
    caseDataInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    caseDataInfo(val) {
      if (val.companyCode) {
        this.checked = "是";
      }
    }
  },
  created() {},
  methods: {
    companyCodeChange(val, cb) {
      getByCompanyCode({ companyCode: val }).then(res => {
        this.companyCodeList = res.data;
        cb(this.companyCodeList);
      });
    },
    companyCodeHandle(item) {},
    companyNameChange(val, cb) {
      getZcByCompanyName({ companyFullName: val }).then(res => {
        this.companyNameList = res.data;
        console.log("-----------", this.companyNameList);
        this.companyNameList.forEach(item => {
          item.value = item.companyFullName;
        });
        cb(this.companyNameList);
      });
    },
    companyNameHandle(item) {
      this.caseDataInfo.companyCode = item.id;
      this.caseDataInfo.companyName = item.companyFullName;
    }
  }
};
</script>

<style scoped lang="less">
.entity-association-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .entity-association-block {
    border-bottom: 20px solid #d8efff;

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>
